import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldStyledBadgeLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledBadgeLabel';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';

const POSITION_OPTIONS = {
    orange: {
        rectColour: CATEGORIES.display.color,
        options: [
            { value: 'UPPER_LEFT', label: '左上' },
            { value: 'LOWER_LEFT', label: '左下' },
            { value: 'UPPER_RIGHT', label: '右上' },
            { value: 'LOWER_RIGHT', label: '右下' },
        ],
    },
    blue: {
        rectColour: CATEGORIES.display.color,
        options: [
            { value: 'UPPER_LEFT', label: '左上' },
            { value: 'LOWER_LEFT', label: '左下' },
            { value: 'UPPER_RIGHT', label: '右上' },
            { value: 'LOWER_RIGHT', label: '右下' },
        ],
    },
} as const;

defineBlock({
    type: 'seven_seg_string',
    colour: CATEGORIES.display.color,
    tooltip: '7セグメントディスプレイに文字を表示します',
    movable: true,
    deletable: true,
    previousStatement: true,
    nextStatement: true,
    inline: true,
    inputs: [
        {
            kind: 'dummy',
            fields: [
                { type: 'image', icon: { src: '/images/block/seven_seg.svg', size: 65 } },
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('7SEG', { fontSize: 15, fontWeight: 'bold' }),
                },
                {
                    type: 'field',
                    instance: () => new FieldStyledBadgeLabel('文字'),
                },
                { type: 'label', text: ' ' },
                {
                    type: 'dropdown',
                    name: 'POSITION',
                    rectColour: POSITION_OPTIONS.orange.rectColour,
                    options: [...POSITION_OPTIONS.orange.options],
                },
                { type: 'label', text: 'に' },
            ],
        },
        {
            kind: 'value',
            name: 'DIGIT_0',
            check: ['SevenSegChar', 'String'],
            shadow: { type: 'string_seven_seg', fields: { CHAR: ' ' } },
        },
        {
            kind: 'value',
            name: 'DIGIT_1',
            check: ['SevenSegChar', 'String'],
            shadow: { type: 'string_seven_seg', fields: { CHAR: ' ' } },
        },
        {
            kind: 'value',
            name: 'DIGIT_2',
            check: ['SevenSegChar', 'String'],
            shadow: { type: 'string_seven_seg', fields: { CHAR: ' ' } },
        },
        {
            kind: 'value',
            name: 'DIGIT_3',
            check: ['SevenSegChar', 'String'],
            shadow: { type: 'string_seven_seg', fields: { CHAR: ' ' } },
        },
        {
            kind: 'dummy',
            fields: [{ type: 'label', text: 'を表示する ' }],
        },
    ],
});
